/**
 * @generated SignedSource<<bc80cc11ea20a8c6e36dd6a82fcb8445>>
 * @relayHash 1550b53499cc9c4c43997e297fa050c5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 10738af8cd0e26e61c93e96a9aa88d2a81fd8fade160ae57f575778fdf62b7c5

import type { ConcreteRequest } from 'relay-runtime';
export type useCommerceDeepLinksCcpTransactionAccountIdQuery$variables = {
  entitlementId: string;
  targetEditionName?: string | null;
};
export type useCommerceDeepLinksCcpTransactionAccountIdQuery$data = {
  readonly ccp: {
    readonly entitlement: {
      readonly experienceCapabilities: {
        readonly changeOfferingV2: {
          readonly experienceUrl: string | null;
        } | null;
      } | null;
      readonly id: string;
      readonly transactionAccountId: string | null;
    } | null;
  } | null;
};
export type useCommerceDeepLinksCcpTransactionAccountIdQuery = {
  response: useCommerceDeepLinksCcpTransactionAccountIdQuery$data;
  variables: useCommerceDeepLinksCcpTransactionAccountIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entitlementId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "targetEditionName"
  }
],
v1 = [
  {
    "concreteType": "CcpQueryApi",
    "kind": "LinkedField",
    "name": "ccp",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "entitlementId"
          }
        ],
        "concreteType": "CcpEntitlement",
        "kind": "LinkedField",
        "name": "entitlement",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "transactionAccountId"
          },
          {
            "concreteType": "CcpEntitlementExperienceCapabilities",
            "kind": "LinkedField",
            "name": "experienceCapabilities",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "offeringName",
                    "variableName": "targetEditionName"
                  }
                ],
                "concreteType": "CcpChangeOfferingExperienceCapability",
                "kind": "LinkedField",
                "name": "changeOfferingV2",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "experienceUrl"
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useCommerceDeepLinksCcpTransactionAccountIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCommerceDeepLinksCcpTransactionAccountIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1550b53499cc9c4c43997e297fa050c5",
    "id": "10738af8cd0e26e61c93e96a9aa88d2a81fd8fade160ae57f575778fdf62b7c5",
    "metadata": {},
    "name": "useCommerceDeepLinksCcpTransactionAccountIdQuery",
    "operationKind": "query",
    "text": "query useCommerceDeepLinksCcpTransactionAccountIdQuery($entitlementId:ID!,$targetEditionName:String){ccp{entitlement(id:$entitlementId){transactionAccountId,experienceCapabilities{changeOfferingV2(offeringName:$targetEditionName){experienceUrl}},id}}}"
  }
};
})();

(node as any).hash = "0078d9648e47947324143eae530f4046";

export default node;
